import { render, staticRenderFns } from "./Confirmar.vue?vue&type=template&id=2feca0f6&scoped=true&"
import script from "./Confirmar.vue?vue&type=script&lang=js&"
export * from "./Confirmar.vue?vue&type=script&lang=js&"
import style0 from "./Confirmar.vue?vue&type=style&index=0&id=2feca0f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feca0f6",
  null
  
)

export default component.exports